import React, { useState } from 'react';

const AddRecipePage = () => {
    // Initial state matching the RECIPES_DATA_LOCAL structure
    const [recipe, setRecipe] = useState({
        name: '',
        price: '',
        prep_time: '',
        servings: 1,
        image_url: '/images/placeholder-main.png',
        ingredients: [],
        preparation_steps: [],
        gallery: [],
        category: 'cat-frozen-001'
    });

    // Temporal states for form input handling
    const [tempIngredient, setTempIngredient] = useState({ item: '', amount: '' });
    const [tempStep, setTempStep] = useState('');
    const [tempGalleryItem, setTempGalleryItem] = useState({ url: '', alt: '' });

    /**
     * Appends a new ingredient object to the recipe state
     */
    const addIngredient = () => {
        if (tempIngredient.item && tempIngredient.amount) {
            setRecipe({
                ...recipe,
                ingredients: [...recipe.ingredients, { ...tempIngredient, checked: false }]
            });
            setTempIngredient({ item: '', amount: '' });
        }
    };

    /**
     * Adds a sequential preparation step
     */
    const addStep = () => {
        if (tempStep) {
            const newStepNumber = recipe.preparation_steps.length + 1;
            setRecipe({
                ...recipe,
                preparation_steps: [
                    ...recipe.preparation_steps,
                    { step: newStepNumber, description: tempStep, checked: false }
                ]
            });
            setTempStep('');
        }
    };

    /**
     * Adds an image object to the gallery array with order indexing
     */
    const addGalleryImage = () => {
        if (tempGalleryItem.url && tempGalleryItem.alt) {
            const newOrder = recipe.gallery.length + 1;
            setRecipe({
                ...recipe,
                gallery: [
                    ...recipe.gallery,
                    { ...tempGalleryItem, order: newOrder }
                ]
            });
            setTempGalleryItem({ url: '', alt: '' });
        }
    };

    /**
     * Validates and logs the final JSON structure for local data integration
     */
    const handleSave = () => {
        if (!recipe.name || !recipe.price) {
            console.error("Required fields missing: name or price.");
            return;
        }

        const finalRecipe = {
            _id: crypto.randomUUID(),
            name: recipe.name,
            price: Number(recipe.price),
            prep_time: recipe.prep_time || "0 min",
            servings: Number(recipe.servings) || 1,
            image_url: recipe.image_url,
            ingredients: recipe.ingredients,
            preparation_steps: recipe.preparation_steps,
            gallery: recipe.gallery,
            category: recipe.category,
            created_at: { "$date": new Date().toISOString() }
        };

        console.log("✅ GENERATED JSON - Copy this into RECIPES_DATA_LOCAL:");
        console.log(JSON.stringify(finalRecipe, null, 2));
    };

    return (
        <main className="new-recipe-container">
            <header className="header">
                <h1>Crear Nueva Receta</h1>
                <button className="save-btn" onClick={handleSave}>💾 Generar JSON</button>
            </header>

            <section className="form-section">


                <div className="form-card main-info">
                    <h3>Información General</h3>

                    <div className="main-image-selector">
                        <img src={recipe.image_url} alt="Previsualización" className="pre-img" />
                        <div className="input-group">
                            <label>Ruta Imagen Principal (ej: /images/mi-batido.jpg)</label>
                            <input
                                type="text"
                                placeholder="/images/productos/shack-choco.png"
                                onChange={(e) => setRecipe({...recipe, image_url: e.target.value})}
                            />
                            <p className="help-text">Primero guarda la imagen en la carpeta 'public/images/' de tu proyecto.</p>
                        </div>
                    </div>

                    <div className="input-group">
                        <label>Nombre de la receta</label>
                        <input type="text" placeholder="Ej: Milkshake de Chocolate" onChange={(e) => setRecipe({...recipe, name: e.target.value})} />
                    </div>

                    <div className="input-row">
                        <div className="input-group">
                            <label>Precio ($)</label>
                            <input type="number" placeholder="12000" onChange={(e) => setRecipe({...recipe, price: e.target.value})} />
                        </div>
                        <div className="input-group">
                            <label>Tiempo (min)</label>
                            <input type="text" placeholder="3 min" onChange={(e) => setRecipe({...recipe, prep_time: e.target.value})} />
                        </div>
                    </div>
                </div>

                <div className="form-card manager-section">
                    <h3>Ingredientes</h3>
                    <div className="add-row">
                        <input
                            placeholder="Ej: Leche"
                            value={tempIngredient.item}
                            onChange={(e) => setTempIngredient({...tempIngredient, item: e.target.value})}
                        />
                        <input
                            placeholder="Ej: 200 ml"
                            value={tempIngredient.amount}
                            onChange={(e) => setTempIngredient({...tempIngredient, amount: e.target.value})}
                        />
                        <button type="button" className="add-btn" onClick={addIngredient}>+</button>
                    </div>
                    <ul className="item-list">
                        {recipe.ingredients.map((ing, i) => (
                            <li key={i}>✅ {ing.amount} - {ing.item}</li>
                        ))}
                    </ul>
                </div>

                <div className="form-card manager-section">
                    <h3>Pasos de Preparación</h3>
                    <div className="add-row">
                        <input
                            placeholder="Descripción del paso"
                            value={tempStep}
                            onChange={(e) => setTempStep(e.target.value)}
                        />
                        <button type="button" className="add-btn" onClick={addStep}>+</button>
                    </div>
                    <ol className="step-list">
                        {recipe.preparation_steps.map((s, i) => (
                            <li key={i}>{s.description}</li>
                        ))}
                    </ol>
                </div>

                <div className="form-card manager-section gallery-admin">
                    <h3>Galería de Apoyo (Opcional)</h3>
                    <div className="add-row gallery-inputs">
                        <input
                            placeholder="Ruta Imagen (ej: /images/galeria/paso1.jpg)"
                            value={tempGalleryItem.url}
                            onChange={(e) => setTempGalleryItem({...tempGalleryItem, url: e.target.value})}
                        />
                        <input
                            placeholder="Descripción Alt (ej: Licuando)"
                            value={tempGalleryItem.alt}
                            onChange={(e) => setTempGalleryItem({...tempGalleryItem, alt: e.target.value})}
                        />
                        <button type="button" className="add-btn" onClick={addGalleryImage}>+</button>
                    </div>

                    <div className="gallery-preview">
                        {recipe.gallery.map((img, i) => (
                            <div key={i} className="gallery-item-pre">
                                <img src={img.url} alt={img.alt} />
                                <span className="order-badge">{img.order}</span>
                            </div>
                        ))}
                    </div>
                </div>

            </section>
        </main>
    );
};

export default AddRecipePage;